var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsefulLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:customer-support"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 7.70333C11.3333 7.47267 11.3333 7.35733 11.3679 7.25467C11.4686 6.956 11.7346 6.84067 12.0013 6.71933C12.2999 6.58267 12.4493 6.51467 12.5979 6.50267C12.7659 6.48933 12.9346 6.52533 13.0786 6.606C13.2693 6.71267 13.4026 6.91667 13.5386 7.082C14.1673 7.846 14.4819 8.228 14.5966 8.64867C14.6899 8.98867 14.6899 9.34467 14.5966 9.684C14.4293 10.2987 13.8993 10.8133 13.5066 11.2907C13.3059 11.534 13.2053 11.656 13.0786 11.7273C12.9321 11.8086 12.7649 11.8445 12.5979 11.8307C12.4493 11.8187 12.2999 11.7507 12.0006 11.614C11.7339 11.4927 11.4686 11.3773 11.3679 11.0787C11.3333 10.976 11.3333 10.8607 11.3333 10.63V7.70333ZM4.66661 7.70333C4.66661 7.41267 4.65861 7.152 4.42394 6.948C4.33861 6.874 4.22527 6.82267 3.99927 6.71933C3.69994 6.58333 3.55061 6.51467 3.40194 6.50267C2.95727 6.46667 2.71794 6.77067 2.46194 7.08267C1.83261 7.846 1.51794 8.228 1.40261 8.64933C1.30981 8.98821 1.30981 9.34579 1.40261 9.68467C1.57061 10.2987 2.10127 10.814 2.49327 11.2907C2.74061 11.5907 2.97727 11.8647 3.40194 11.8307C3.55061 11.8187 3.69994 11.7507 3.99927 11.614C4.22594 11.5113 4.33861 11.4593 4.42394 11.3853C4.65861 11.1813 4.66661 10.9207 4.66661 10.6307V7.70333Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33301 6.5C3.33301 4.29067 5.42234 2.5 7.99967 2.5C10.577 2.5 12.6663 4.29067 12.6663 6.5M12.6663 11.8333V12.3667C12.6663 13.5447 11.473 14.5 9.99967 14.5H8.66634",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsefulLine);
export default __webpack_public_path__ + "static/media/useful-line.179821cf1d6e2b215c46ddd3486d47ee.svg";
export { ForwardRef as ReactComponent };